// Suggested formation leads shown before the user types a search query.
export const DEFAULT_FORMATION_LEAD_EMAILS: string[] = [
  'mdolan@linuxfoundation.org',
  'snicholas@linuxfoundation.org',
  'tbenzies@linuxfoundation.org',
  'jburson@linuxfoundation.org',
];
